import React, {useEffect,useState,useContext, useRef,useCallback} from "react";
import Grid from "@mui/material/Grid";
// import "../../pages/Plan.css";
import { purchaseService } from "../../services/purchase.service";

import LogicContext from "../../Context/LogicContext";
import { GetEntryData} from '../../store/vendorAtom';

import { useForm } from "react-hook-form";

import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import VendorSalutationComponent from "./VendorSalutationComponent";
import VendorImageComponent from "./VendorImageComponent";
import { GetVendorEdit, SetVendorEdit} from '../../store/vendorAtom';
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";



const AddVendorGeneralInfoTab = (props) => {
  document.title = 'Add new Vendor';
    const myPromiseModal = createModal(GeneralModal);
    const vendorToEdit = GetVendorEdit();
    const setVendorToEdit = SetVendorEdit();
    const {register,setValue,getValues,handleSubmit,control,reset,formState: { errors }} = useForm();
    const logicContext = useContext(LogicContext);
    const [selectedImage, setSelectedImage] = useState(undefined);

    const mountRef = useRef(true);

    useEffect(()=> {
      if(vendorToEdit?.Vendor_Id){
        setValue('Salutation_Id', vendorToEdit?.Salutation_Id);
        setValue('Vendor_First_Name', vendorToEdit?.Vendor_First_Name);
        setValue('Vendor_Last_Name', vendorToEdit?.Vendor_Last_Name);
        setValue('Vendor_Email_Address', vendorToEdit?.Vendor_Email_Address);
        setValue('Vendor_Mobile_No', vendorToEdit?.Vendor_Mobile_No);
        setValue('Vendor_Image_URL', vendorToEdit?.Vendor_Image_URL);
        setValue('Vendor_Company_Name', vendorToEdit?.Vendor_Display_Name);
      
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[vendorToEdit])



  function onSalutationSelect(val) {
    setValue("Payment_Term_Id", val.Code);
  }


  const onSubmit = async (option) => {
    const formData = getValues();


    await myPromiseModal({ title: "Confirmation",body: " Do you want to save this record?",
    showInput:false, placeHolder:'' })
      .then((res) => {
        if (res.decision === true) {
          let option = 1;
          const newData = getValues();
       
   
          const formData = new FormData();
          for (const keyData in newData) {
            formData.set(keyData, newData[keyData] ? newData[keyData] : 0);
          }
         
          if(selectedImage !== undefined){
            formData.set('file', selectedImage)
        

          }
          if(vendorToEdit?.Vendor_Id){
            option = 2
            formData.set('Vendor_Id', vendorToEdit.Vendor_Id);
          }
          formData.set('option',option)
        
          purchaseService.submitVendor(formData).then((res) => {
              const serverData =  toLowercaseKeys(res.data);
                  const cleanResponse = logicContext.httpResponseManager(serverData?.[0] || serverData?.result_status?.[0]);
               const { message_id, message_text, message_ref_no } = cleanResponse;
               if (message_id == 1) {
                setVendorToEdit((prev)=> {
                  return {...prev, Vendor_Id:message_ref_no}
                });
                logicContext.showToast(message_text, "success");

                props.onDynamicTabSelect(1);
              } else {
                logicContext.showToast(res.data["msg"], "error");
              }

          });
        }
      })
      .catch((err) => {
        logicContext.showToast("error submitting record", "error");
      })
      .catch((err) => {
        logicContext.showToast( "error submitting form, please try again","error");
      });
  };

  function onErrors(error) {
    console.error("Errorrrrr ", error);
    logicContext.showToast("Form error", "error");
  }


  const submitItemImage = (imageFile)=> {
        setSelectedImage(imageFile);
    }



    return (
      <>
        <form onSubmit={handleSubmit(onSubmit, onErrors)}>
          <section className="container max-auto  ">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <span className="text-sm text-bold">Primary contacts details</span>
                <br></br>
                <span className="text-sm ">
                  Salutation <i>(Optional)</i>
                </span>
                <VendorSalutationComponent defaultVal={{ label: vendorToEdit?.Salutation_Name }} onSalutationSelect={onSalutationSelect} />

                <div className="">
                  <span className="text-sm ">First Name</span>
                  <span className="text-danger font-bold">*</span>
                  <div className="">
                    <input
                      type="text"
                      className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                      placeholder="enter first name "
                      {...register('Vendor_First_Name', {
                        required: 'First Name is required!',
                      })}
                    />
                  </div>
                  <small className="text-danger">{errors?.Vendor_First_Name && errors.Vendor_First_Name.message}</small>
                </div>

                <div className="">
                  <span className="text-sm ">Last Name</span>
                  <span className="text-danger font-bold">*</span>
                  <div className="">
                    <input
                      type="text"
                      className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                      placeholder="enter last name"
                      {...register('Vendor_Last_Name', {
                        required: 'Last Name is required!',
                      })}
                    />
                  </div>
                  <small className="text-danger">{errors?.Vendor_Last_Name && errors.Vendor_Last_Name.message}</small>
                </div>
              </Grid>

              <Grid item xs={6} className="flex justify-center">
                <div>
                  <VendorImageComponent imgSrc={vendorToEdit?.Vendor_Image_URL} submitItemImage={submitItemImage} />

                  <div>
                    {' '}
                    <i>image should not exceeding 5 MB</i>
                  </div>
                </div>
              </Grid>

              <Grid item xs={6}>
                <span className="text-sm ">Email</span>
                <input
                  type="email"
                  className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                  placeholder="Enter Email"
                  {...register('Vendor_Email_Address', {
                    required: 'Email address is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Please enter a valid email address',
                    },
                  })}
                />
                <small className="text-danger">{errors?.Vendor_Email_Address && errors.Vendor_Email_Address.message}</small>

              </Grid>

              <Grid item xs={6}>
                <span className="text-sm ">Company Name</span>
                <span className="text-danger font-bold">*</span>
                <input
                  type="text"
                  className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                  placeholder="Enter Company Name"
                  {...register('Vendor_Company_Name', {
                    required: 'Company Name is required!',
                  })}
                />
                <small className="text-danger">{errors?.Vendor_Company_Name && errors.Vendor_Company_Name.message}</small>
                <br />
                <br />
              </Grid>
              <Grid item xs={6}>
                <span className="text-sm ">Work Phone Number</span>
                <span className="text-danger font-bold">*</span>
                <input
                  type="text"
                  className="bg-filterInput pl-3 rounded max-h-full  w-full bottom-0 outline-none border-transparent focus:border-transparent focus:ring-0"
                  placeholder="enter work phone number"
                  {...register('Vendor_Mobile_No', {
                    required: 'Mobile Number is required!',
                  })}
                />
                <small className="text-danger">{errors?.vendor_Mobile_No && errors.vendor_Mobile_No.message}</small>
              </Grid>

              <Grid item xs={12}>
                <section>
                  <div className="gird grid-cols-2 flex justify-between my-10 gap-4 w-full">
                    <button type="button" style={{ color: '#F17E7E', backgroundColor: 'white' }} className="text-sm rounded">
                      CANCEL
                    </button>
                    <div>
                      <span type="submit" style={{ color: '#476EF8' }} className="text-sm  px-3 rounded mr-10 py-2">
                        SAVE AS DRAFT
                      </span>
                      <button type="submit" style={{ backgroundColor: '#476EF8' }} className="text-sm text-white px-3 rounded py-2">
                        SAVE
                      </button>
                    </div>
                  </div>
                </section>
              </Grid>
            </Grid>
          </section>
        </form>
      </>
    );
}
 
export default AddVendorGeneralInfoTab;